import { render, staticRenderFns } from "./AddVisit.vue?vue&type=template&id=39048c33&scoped=true"
import script from "./AddVisit.vue?vue&type=script&lang=js"
export * from "./AddVisit.vue?vue&type=script&lang=js"
import style0 from "./AddVisit.vue?vue&type=style&index=0&id=39048c33&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39048c33",
  null
  
)

export default component.exports